import { render } from "./teacherPromot.vue?vue&type=template&id=81b44ad8&scoped=true"
import script from "./teacherPromot.vue?vue&type=script&lang=js"
export * from "./teacherPromot.vue?vue&type=script&lang=js"

import "./teacherPromot.vue?vue&type=style&index=0&id=81b44ad8&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b44ad8"]])

export default __exports__